module.exports = __webpack_public_path__ + "499f591422b3218d9052c7a1cd996ab2.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/sounds/background/river.mp3
// module id = 3262
// module chunks = 0